import { createReducer, on, Action } from '@ngrx/store';
import * as CheckInActions from '../check-in/check-in.action';
import { ICheckIn } from 'src/app/models/check-in';
import { IProxyGroup } from 'src/app/models/proxy-group';

export const initialState: ICheckIn[] = [];

const reducer = createReducer(
  initialState,
  on(CheckInActions.SetProxyObjectAction, (state: ICheckIn[], { checkInProxyObj }) => {
    return state = checkInProxyObj;
  }),
  on(CheckInActions.ClearProxyObjectAction, (state: ICheckIn[]) => state = initialState),

);

export function CheckInProxyReducer(state: ICheckIn[] | undefined, action: Action) {
  return reducer(state, action);
}

export const intialProxyCheckinGroup: IProxyGroup[] = [];

const checkinGroupReducer = createReducer(
  intialProxyCheckinGroup,
  on(CheckInActions.SetProxyGroupCheckInObjectAction, (state: IProxyGroup[], { checkInProxyGroupObj }) => {
    return state = checkInProxyGroupObj;
  }),
  on(CheckInActions.ClearProxyGroupCheckInObjectAction, (state: ICheckIn[]) => state = intialProxyCheckinGroup),

);

export function CheckInProxyGroupReducer(state: ICheckIn[] | undefined, action: Action) {
  return checkinGroupReducer(state, action);
}
